import React, { useContext } from 'react'; 
import Context from '../../../Context';

 
 
function UserGuide(){
    const cx=useContext(Context);
    cx.breadCrumbsAdd(cx.t("pages.guide"));
    return(
        <div className="card card-custom gutter-b">            
            <div className="card-body">
                В настоящий момент руководство пользователя отсутствует
            </div>
        </div>
    )
}
export default UserGuide;